import { organizationRoutes } from '@/backend/config/routes';
import { allowUserSendMessages } from '@/backend/features/permissions/utils';
import { NotificationsWidget } from '@juvare/alert-ui/ui/features/alerts';
import { AlertFab } from '@juvare/alert-ui/ui/features/alerts/components/AlertFab';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { allowAccessToPendingMemberships } from '@juvare/contact-management/backend/features/permissions/shared';
import { PendingMemberships } from '@juvare/contact-management/ui/features/organizations';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { Box, Card, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import homePageImage from '../assets/images/homePageImage.svg';
import { Announcements } from '../features/announcements/components';

export const HomePanel: React.FC = () => {
    const userState = useUserState();
    const navigate = useNavigate();
    const { t } = useTranslation('healthAlerts');
    const allowSendMessages = allowUserSendMessages(userState);

    return (
        <Box>
            <Box sx={{ height: '100%', overflow: 'auto' }}>
                <PageHeaderWithImage
                    image={homePageImage as string}
                    gradient='blue-dark-angle'
                    title={t('appHeader.title', { firstName: userState?.firstName })}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, pb: 0 }}>
                    <Card variant='outlined' sx={{ p: 2 }}>
                        <Announcements />
                    </Card>
                </Box>
            </Box>
            <Grid container direction='row' justifyContent='space-between' alignItems='stretch' spacing={2} p={2}>
                {allowAccessToPendingMemberships(userState) && (
                    <Grid
                        size={{
                            md: 6,
                            sm: 12,
                            xs: 12,
                        }}
                    >
                        <PendingMemberships
                            onNavigateToOrganizations={() => {
                                const urlParams = new URLSearchParams();
                                urlParams.set('showPendingOnly', JSON.stringify(true));
                                navigate({ pathname: organizationRoutes.root, search: urlParams.toString() });
                            }}
                        />
                    </Grid>
                )}
                <Grid
                    size={{
                        md: 6,
                        sm: 12,
                        xs: 12,
                    }}
                >
                    <NotificationsWidget />
                </Grid>
            </Grid>
            {allowSendMessages && <AlertFab />}
        </Box>
    );
};
